import { FC, useContext } from 'react';
import { Context } from "../../index";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";
import RegistrationForm from "../../component/Authorization/Registration/RegistrationForm";
import Confirmation from "../../component/Authorization/Confirmation/Confirmation";

const Authorization: FC = () => {
    const {store} = useContext(Context);
    const navigate = useNavigate();

    if (!store.isAuth) {
        return (
            <div>
                <RegistrationForm/>
            </div>
        )
    } else if (!store.isActivate) {
        return (
            <div>
                <Confirmation/>
            </div>
        );
    } else {
        navigate("/projects");
        return null;
    }
}

export default observer(Authorization);